import React from "react";
const Renderlpr = ({ list, handleClick }) => {

  return (
    <>
  
        {list && list.length > 0 && list.map((item,index) => {

  return (<div className="card  mt-1" key = {index}>
 <div className="row ms-1">
   <div className="col-xs-12 col-sm-4">


     <div
       className=""
       style={{ fontSize: "15px" }}
     >
       <span className="badge rounded-pill bg-secondary">
         {index+1}
       </span>
     </div>
     <div
       className="mt-1"
       style={{ fontSize: "14px" }}
     >
       {"เวลาล่าสุดที่อ่านได้:"} {item.recordtime}
     </div>

     <div
       className="border-top"
       style={{ fontSize: "14px" }}
     >
       {"ทะเบียน:"}
       {item.drivenno}
     </div>
     <div
       className="border-top"
       style={{ fontSize: "14px" }}
     >
       {"จังหวัด:"} {item.drivenprov}
     </div>
   </div>

   <div className="container col-xs-12 col-sm-4">
     <div
       className="mt-1"
       style={{ fontSize: "14px" }}
     >
       <span style={{ fontSize: "14px" }}>
         {"ประเภทรถ:"} {item.vehicletype}{" "}
       </span>
     </div>
     <div
       className="border-top"
       style={{ fontSize: "14px" }}
     >
       <span style={{ fontSize: "14px" }}>
         {"สี: "}
         <span>{item.color}</span>
       </span>
     </div>

    
   </div>

   <div className="container col-xs-12 col-sm-4">
     <div
       className="mt-1"
       style={{ fontSize: "14px" }}
     >
       <span style={{ fontSize: "14px" }}>
         {"รูป:"}
         <img
           src={item.imageUrl}
           className="img-fluid img-thumbnail m-2"
           style={{
             width: "60px",
             height: "60px",
             cursor: "pointer",
           }}
           alt="..."
           onClick={() => handleClick(item.imageUrl)}
         />
       </span>
     </div>

     <div className="d-flex justify-content-end">
       <div></div>
     </div>
   </div>
 </div>
</div>)

        } ) }
    </>
  );
};

export default Renderlpr;
